export default "__VITE_ASSET__f060f332__"